import GrayCard from "components/gray-card";
import DragNDrop from "components/inputs/dragNdrop";
import Dropdown from "components/inputs/dropdown";
import TextArea from "components/inputs/text-area";
import Typography from "components/typography";
import { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  setMedia: (value: any) => void;
  media?: any;
  songs: string[];
  songsLoading: boolean;
}
const PressPromo = ({ setMedia, media, songs = [], songsLoading }: IProps) => {
  const [pressData, setPressData] = useState({
    media: "",
    note: "",
    file: null
  });

  const OnchangePressData = (key: string, value: any) => {
    const newData = { ...pressData, [key]: value };
    setPressData(newData);
    setMedia(newData);
  };
  return (
    <GrayCard title="Blog/ Press Release">
      <Typography weight="medium" color={Colors.grey400} mb="1.6">
        Select track
      </Typography>

      <DropdownContainer>
        <Dropdown
          placeholder="Choose A Track/ EP / Album"
          chosenItem={media && typeof media === "string" ? media : ""}
          selectItem={(value) => {
            OnchangePressData("media", value);
          }}
          items={songs}
          dataLoading={songsLoading}
        />
      </DropdownContainer>
      <TextContainer>
        <div>
          <Typography color={Colors.grey400} weight="medium" mb="0.8">
            Add A Write-up (optional)
          </Typography>
          <TextArea
            placeholder="Enter text"
            height="20rem"
            value={pressData.note}
            onChange={(e) => OnchangePressData("note", e.target.value)}
          />
        </div>
        <div>
          <Typography color={Colors.grey400} weight="medium" mb="0.8">
            Or Upload
          </Typography>
          <DragNDrop
            setFile={(file) => {
              OnchangePressData("file", file);
            }}
            height="22rem"
            type="doc"
          />
        </div>
      </TextContainer>
    </GrayCard>
  );
};

export default PressPromo;

const DropdownContainer = styled.div`
  width: 30rem;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const TextContainer = styled.div`
  display: grid;
  grid-template-columns: 60% 40%;
  column-gap: 1rem;
  row-gap: 1rem;
  align-items: center;
  margin-top: 2.4rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
  }
`;
